import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Typography, Container } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
import PerformanceDetails from "./PerformanceDetails";

const PerformanceDashboard = () => {
  const { currentTheme } = useTheme();
  const location = useLocation();
  const managerName = location.state?.managerName;
  const managerId = location.state?.managerId;

  /** Set when navigating from Managers overview (see ManagerOverviewDashboard). */
  const fromManagersOverview = Boolean(managerId);

  let heading = "Performance Dashboard";
  if (fromManagersOverview) {
    const name = managerName != null ? String(managerName).trim() : "";
    heading = name || (managerId != null ? `Manager (${String(managerId)})` : heading);
  }

  const documentTitle = fromManagersOverview ? `${heading} | Performance` : "Performance Dashboard | Vantage Alpha";

  return (
    <>
      <Helmet>
        <title>{documentTitle}</title>
      </Helmet>

      <Box
        sx={{
          backgroundColor:
            currentTheme.palette.mode === "light"
              ? "#ebebeb"
              : currentTheme.palette.grey[50],
          background:
            currentTheme.palette.mode === "light"
              ? "#ebebeb"
              : currentTheme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            maxWidth: 1920,
            mx: "auto",
            px: { xs: 2, sm: 3 },
          }}
        >
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: currentTheme.palette.text.primary,
                mb: 1,
              }}
            >
              {heading}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: currentTheme.palette.text.secondary,
              }}
            >
              Comprehensive view of fund and strategy performance metrics
            </Typography>
          </Box>

          <PerformanceDetails />
        </Container>
      </Box>
    </>
  );
};
export default PerformanceDashboard;
